/* Collection page controls (The Poster Club's toolbar, 2026-09-26):
   GALLERY - works per row, 3/4/6 on a computer, 1/2 on a phone;
   Colour  - filter by ONE of the artwork's own colours at a time (product tags color:<Name>); tapping it again clears.
   The layout is remembered in this browser; the filter is not. */
(() => {
  const grid = document.querySelector('[data-coll-grid]');
  if (!grid) return;
  const K = 'melanin:cols', KM = 'melanin:cols-m';
  const get = (k, d) => { try { return localStorage.getItem(k) || d; } catch { return d; } };
  const put = (k, v) => { try { localStorage.setItem(k, v); } catch { /* private mode */ } };
  const press = (sel, attr, v) => document.querySelectorAll(sel).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset[attr] === v)));
  const apply = () => {
    const c = get(K, '3'), m = get(KM, '2');
    grid.style.setProperty('--cols', c); grid.style.setProperty('--cols-m', m);
    press('[data-cols]', 'cols', c); press('[data-cols-m]', 'colsM', m);
  };

  /* Colour filter */
  const HEX = { Black: '#1d1b1a', White: '#f4f1ea', Grey: '#9a9794', Beige: '#d8c3a0', Brown: '#6b4630', Red: '#b3322c',
    Orange: '#d9772f', Yellow: '#e2bd3c', Green: '#4f7a4a', Blue: '#3f5f93', Purple: '#6d4a86', Pink: '#dca0a6',
    /* works where no colour reaches a quarter of the picture (colors.py v2, 2026-09-27) */
    Multicolor: 'conic-gradient(#b3322c, #d9772f, #e2bd3c, #4f7a4a, #3f5f93, #6d4a86, #b3322c)' };
  const ORDER = Object.keys(HEX);
  const cards = Array.from(grid.querySelectorAll('.card'));
  const has = {}; cards.forEach((c) => (c.dataset.colors || '').split(/\s+/).filter(Boolean).forEach((x) => { has[x] = (has[x] || 0) + 1; }));
  const panel = document.querySelector('[data-filter-panel]');
  const toggle = document.querySelector('[data-filter-toggle]');
  const nEl = document.querySelector('[data-filter-n]');
  const countEl = document.querySelector('[data-filter-count]');
  const chosen = new Set();
  const names = ORDER.filter((n) => has[n]);
  if (!names.length && toggle) toggle.hidden = true;
  if (panel) panel.innerHTML = names.map((n) => `<button type="button" data-color="${n}" aria-pressed="false"><i style="background:${HEX[n]}"></i>${n}</button>`).join('')
    + '<button type="button" class="coll-colors__clear" data-color-clear>Clear</button>';
  const filter = () => {
    let shown = 0;
    cards.forEach((c) => {
      const cs = (c.dataset.colors || '').split(/\s+/);
      const ok = !chosen.size || cs.some((x) => chosen.has(x));
      c.hidden = !ok; if (ok) shown++;
    });
    document.querySelectorAll('[data-color]').forEach((b) => b.setAttribute('aria-pressed', String(chosen.has(b.dataset.color))));
    if (nEl) nEl.textContent = chosen.size ? `(${[...chosen][0]})` : '';
    if (countEl) { countEl.hidden = !chosen.size; countEl.textContent = `${shown} ${shown === 1 ? 'work' : 'works'}`; }
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cols], [data-cols-m], [data-filter-toggle], [data-color], [data-color-clear]');
    if (!b) return;
    if (b.dataset.cols) put(K, b.dataset.cols);
    else if (b.dataset.colsM) put(KM, b.dataset.colsM);
    else if (b.hasAttribute('data-filter-toggle')) { panel.hidden = !panel.hidden; b.setAttribute('aria-expanded', String(!panel.hidden)); return; }
    else if (b.dataset.color) { const was = chosen.has(b.dataset.color); chosen.clear(); if (!was) chosen.add(b.dataset.color); filter(); return; } /* one colour at a time (Shalev 2026-09-26); a second tap clears */
    else if (b.hasAttribute('data-color-clear')) { chosen.clear(); filter(); return; }
    apply();
  });
  apply(); filter();
})();
